import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { QueryParams } from '../../../types/strapi/strapi'
import { useCreateContractorMutation } from '../../../store/api/contractors-api'
import useErrorModal from '../../../hooks/api/use-error-modal'
import ClientForm from '../components/clients-form'
import PageLayout from '../../../components/page-layout/page-layout'
import HelpDrawerForm from '../components/help-drawer/help-drawer-form'
import { routes } from '../../../constants/routes'
import { useGetContractorsTypesQuery } from '../../../store/api/contractor-types-api'
import { ClientFormValues } from '../components/clients-form'
import { useCreateContractorContactMutation } from '../../../store/api/contractor-contacts-api'
import { createContacts, buildCreateContractorData } from '../helpers/client-operations'

interface ClientAddPageProps {}

const ClientsAddPage: FC<ClientAddPageProps> = () => {
    const [createClient, createClientState] = useCreateContractorMutation()
    const [createContact, createContactState] = useCreateContractorContactMutation()
    const navigate = useNavigate()
    const params: QueryParams = {
        filters: { name: { $eq: 'Клиент' } },
    }

    const { data: typesData, isLoading: isTypesLoading } = useGetContractorsTypesQuery(params)
    const clientTypeId = typesData?.data?.find(t => t.name === 'Клиент')?.documentId

    const onFinish = async (values: ClientFormValues) => {
        if (!clientTypeId) return

        const contactDocIds = await createContacts(values, {
            createContact: async data => createContact(data).unwrap(),
        })

        const createData = buildCreateContractorData({
            values,
            clientTypeId,
            contactDocIds,
        })

        await createClient({ data: createData }).unwrap()
        navigate(routes.clients)
    }

    useErrorModal(createClientState, 'Не удалось создать клиента')
    useErrorModal(createContactState, 'Не удалось создать контакт клиента')

    return (
        <PageLayout title={'Добавление клиента'} scrollableContent beforeUser={<HelpDrawerForm />}>
            <ClientForm
                onFinish={onFinish}
                loading={createClientState.isLoading || isTypesLoading}
                submitText='Добавить клиента'
            />
        </PageLayout>
    )
}

export default ClientsAddPage
